import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import "./UserAvatar.css";

function UserAvatar({ size = "medium", showName = false }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/account");
  };

  const getInitials = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase();
    } else if (user?.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return "U";
  };

  const getUserName = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName} ${user.lastName}`;
    } else if (user?.email) {
      return user.email;
    }
    return "User";
  };

  return (
    <div
      className={`user-avatar-component-container ${showName ? "with-name" : "icon-only"}`}
      onClick={handleClick}
      title="View Account"
    >
      <div
        className={`user-avatar-circle ${size} ${user?.profileImageUrl ? "has-image" : ""}`}
        style={
          user?.profileImageUrl
            ? {
                backgroundImage: `url(${user.profileImageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }
            : {}
        }
      >
        {user?.profileImageUrl ? null : getInitials()}
      </div>
      {showName && (
        <div className="user-avatar-component-user-name">{getUserName()}</div>
      )}
    </div>
  );
}

export default UserAvatar;
